import {
  JaBack,
  JaCalf,
  JaElbow,
  JaFallPrevention,
  JaFoot,
  JaHand,
  JaHip,
  JaKnee,
  JaNeck,
  JaOsteoporosis,
  JaShoulder,
  LogoIcon,
} from "assets";

export const GroupIcon = ({ group }: { group: string | null | undefined }) => {
  switch (group) {
    case "back":
      return <JaBack />;
    case "elbow":
      return <JaElbow />;
    case "fall_prevention":
      return <JaFallPrevention />;
    case "foot":
      return <JaFoot />;
    case "hand":
      return <JaHand />;
    case "hip":
      return <JaHip />;
    case "knee":
      return <JaKnee />;
    case "lower_leg":
      return <JaCalf />;
    case "neck":
      return <JaNeck />;
    case "osteoporosis":
      return <JaOsteoporosis />;
    case "shoulder":
      return <JaShoulder />;
    default:
      return <LogoIcon />;
  }
};
